import { useState } from "react";
import "./GameControl.css";
import { GameMode } from "../../types/game";
import ConfirmationModal from "../ui/ConfirmationModal";
import useGameStore from "../../context/GameContext";

const GameControls = () => {
  // 使用游戏上下文
  const { startGame, isGameActive, getAllLibraryNames, currentMode } =
    useGameStore();
  const allLibraryNames = getAllLibraryNames();

  // 本地组件状态，跟踪选中的库
  // 这不是zustand中使用的全局变量。全局变量仅在触发新游戏是变化，此本地变量跟随下拉选择框变化
  const [localSelectedLibrary, setLocalSelectedLibrary] = useState("");

  // 选择变化时的处理函数
  const handleLibraryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLocalSelectedLibrary(e.target.value);
  };

  // 模式切换确认弹窗状态
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  // 暂存用户要切换的新模式
  const [pendingMode, setPendingMode] = useState<GameMode | null>(null);

  // 处理模式按钮点击
  const handleModeButtonClick = (mode: GameMode) => {
    if (isGameActive) {
      // 如果游戏正在进行中，显示确认弹窗
      setPendingMode(mode);
      setShowConfirmModal(true);
    } else {
      // 如果没有游戏进行中，直接启动新游戏
      if (localSelectedLibrary) {
        startGame(mode, localSelectedLibrary);
      }
    }
  };

  // 确认开始新游戏
  const confirmStartNewGame = () => {
    if (pendingMode && localSelectedLibrary) {
      // 使用startGame完全重置并启动新游戏
      startGame(pendingMode, localSelectedLibrary);
    }

    setShowConfirmModal(false);
    setPendingMode(null);
  };

  // 取消开始新游戏
  const cancelStartNewGame = () => {
    setShowConfirmModal(false);
    setPendingMode(null);
  };

  return (
    <>
      <div className="controls-bar">
        <div className="mode-selector">
          {(["matching", "sequential", "allTogether"] as GameMode[]).map(
            (mode) => (
              <button
                key={mode}
                className={`mode-button ${
                  currentMode === mode ? "active" : ""
                }`}
                onClick={() => handleModeButtonClick(mode)}
              >
                {getModeLabel(mode)}
              </button>
            )
          )}
        </div>

        <div className="library-selector">
          <select
            value={localSelectedLibrary || ""} // 处理 null 值
            onChange={handleLibraryChange}
            className="library-dropdown"
          >
            <option value="">选择题库</option>
            {allLibraryNames.map((library) => (
              <option key={library} value={library}>
                {library}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* 开始新游戏确认弹窗 */}
      <ConfirmationModal
        isOpen={showConfirmModal}
        message={
          pendingMode === currentMode
            ? "确定要重新开始游戏吗？"
            : "确定要开始新的游戏吗？"
        }
        onConfirm={confirmStartNewGame}
        onCancel={cancelStartNewGame}
      />
    </>
  );
};

const getModeLabel = (mode: GameMode) => {
  switch (mode) {
    case "matching":
      return "消消乐模式";
    case "sequential":
      return "依次答题模式";
    case "allTogether":
      return "全部答题模式";
    default:
      return "";
  }
};

export default GameControls;
